import { render, staticRenderFns } from "./add-lp.vue?vue&type=template&id=50d50bc3&scoped=true&"
import script from "./add-lp.vue?vue&type=script&lang=js&"
export * from "./add-lp.vue?vue&type=script&lang=js&"
import style0 from "./add-lp.vue?vue&type=style&index=0&id=50d50bc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d50bc3",
  null
  
)

export default component.exports